export default __webpack_public_path__ + "static/media/IconSkull.9f6bb10c.svg";